// Frans (fr-FR), kioskBoard: zelfde vorm als kioskBoard.nl.ts. Tu-vorm, korte woorden voor
// kinderen; wat ontbreekt valt terug op het Nederlands.
export const kioskBoardFr = {
    weekToggle: 'Semaine',
    weekTitle: 'Semaine {week}',
    weekTitleToday: 'Aujourd’hui - Semaine {week}',
    backToToday: 'Aujourd’hui',
    menu: 'Plus',
    menuMake: 'Créer',
    menuHome: 'Maison',
    menuBoard: 'Tableau',
    boardRefreshing: 'Actualisation…',
    boardLoading: 'Chargement…',
    boardRefreshFailed: 'Actualisation impossible : pas de connexion. Le tableau affiche les dernières données connues.',
    pageOf: 'Page {n} sur {total}',
    prevWeek: 'Semaine précédente',
    nextWeek: 'Semaine suivante',
    weekEmpty: 'Cette semaine est encore vide',
    // Agendapagina van het bord (oprichter 1 okt 2026): Dag/Week, filter op personen.
    modeDay: 'Jour',
    modeWeek: 'Semaine',
    agendaMode: 'Affichage',
    prevDay: 'Jour précédent',
    nextDay: 'Jour suivant',
    filterPeople: 'Afficher pour',
    noEventsWeek: 'Aucun rendez-vous cette semaine',
    noEventsDay: 'Aucun rendez-vous ce jour-là',
    noEventsFor: 'Rien de prévu pour {names}',
    // Maandweergave van de agendapagina (oprichter 1 okt 2026).
    modeMonth: 'Mois',
    prevMonth: 'Mois précédent',
    nextMonth: 'Mois suivant',
    noEventsMonth: 'Aucun rendez-vous ce mois-ci',
    // Reistijd-knop op de agendapagina (oprichter 1 okt 2026): ritten tonen of verbergen.
    travelToggle: 'Trajets',
    rideBring: 'Déposer',
    rideFetch: 'Récupérer',
    rideOnTheWay: 'En route',
    rideBack: 'Retour',
    moreItems: '+{count}',
    laterAt: 'Plus tard · {time}',
    nowUntil: 'Maintenant · jusqu’à {time}',
    scrollMore: 'Plus d’événements',
    tasksMore: 'Plus de tâches',
    tasksLess: 'Retour en haut',
    departClose: 'Fermer l’alerte',
    departWho: '{names} : départ à {time} pour {title}',
    // Rijders op de detailkaart (oprichter 1 okt: alles vertaald).
    rideDropoff: '{name} emmène',
    ridePickup: '{name} va chercher',
    and: 'et',
    travel: '{minutes} min de trajet',
    leaveAt: 'départ à {time}',
    /** 0056: reistijd terug: thuis rond deze tijd. */
    travelBack: 'à la maison à {time}',
    conflict: 'En même temps qu’autre chose',
    continues: 'Se poursuit',
    tomorrowFirst: 'Demain à {time} : {title}',
    waitingApproval: 'Attend papa ou maman',
    klaarApproval: 'Papa ou maman va encore vérifier.',
    doneBy: '{name} l’a fait en premier',
    claimedBy: '{name} s’en occupe',
    tryAgain: 'On réessaie ?',
    notSaved: 'Ça n’a pas marché',
    cloudPending: 'Enregistrement…',
    memberRail: 'La famille',
    pointsReserved: '{count} en réserve',
    rewardsTile: 'Récompenses',
    rewardsOf: 'Récompenses de {name}',
    goal: 'Objectif : {name}',
    goalProgress: '{value} sur {max}',
    goalHint: 'Un objectif à choisir ensemble',
    rewardCanGet: 'Tu peux !',
    /** Rustig, buiten het thema Kinderen. */
    rewardCanGetCalm: 'Disponible',
    rewardMissing: 'Encore {count}',
    rewardWaiting: 'Attend papa ou maman',
    rewardBusy: 'D’abord l’autre',
    rewardLimit: 'Revient demain',
    rewardSoldOut: 'Épuisé',
    rewardCancel: 'Annuler',
    whoAreYou: 'Qui es-tu ?',
    requestQuestion: 'Demander {reward} ?',
    cancelQuestion: 'Annuler {reward} ?',
    keepIt: 'Non, je garde',
    cancelYes: 'Oui, annuler',
    notYou: 'Ce n’est pas toi ?',
    areYou: 'Tu es {name} ?',
    yesMe: 'Oui, c’est moi',
    notMe: 'Non',
    notYours: 'C’est à {name}',
    notYoursBody: 'Regarde, voici ta liste.',
    closeRewards: 'Retour à Aujourd’hui',
    detailClose: 'Fermer',
    detailEdit: 'Modifier',
    sleepWell: 'Bonne nuit',
    tomorrowAt: 'Demain à {time} : {title}',
    calmDown: 'Doucement…',
    upcoming: 'Bientôt',
    tomorrowEmpty: 'Rien de prévu pour l’instant',
    inDays: { one: 'dans {count} jour', other: 'dans {count} jours' },
};
//# sourceMappingURL=kioskBoard.fr.js.map